<template>
  <div id="app" v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {
    this.windowResize();
  },
  methods: {
    windowResize() {
      // window.addEventListener('resize', () => {
      //   console.log(document.body.clientWidth);
      //   document
      // });
    }
  }
};
</script>

<style lang="scss">
body {
  background-color: #EFEFEF;
}

.pl13 {
  padding-left: 20px;
}

.pc-table-color .el-table th.el-table__cell:first-child {}

.pc-table-pl .el-table th.el-table__cell:first-child {
  padding-left: 20px;
}

.detail-left-height {
  height: calc(100vh - 98px);
  overflow: auto;
}

#app .posi-head {
  .posi-title {
    font-size: 18px;
  }

  img {
    width: 35px;
    height: 35px;
  }
}

[v-cloak] {
  display: none;
}

.el-cascader {
  width: 100%;
}

.opacity {
  animation: 0.3s 0s opacity;
}

@keyframes opacity {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.el-message {
  z-index: 10000 !important;
}

.detail .detail-main .detail-right .detail-view {
  overflow-y: auto;
  height: calc(100vh - 151px) !important;
}

.detail .detail-main .detail-left .detail-left-btn {
  position: absolute !important;
  margin-top: 0;
  bottom: 0;
}

.detail .detail-main .detail-left {
  padding-bottom: 0 !important;
  overflow-y: hidden;
}

.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: contain;
}

.content {
  .content_search {
    .input_inner {
      .el-input__inner {
        border: 1px solid #DCDCDC !important;
        width: 100% !important;
      }
    }
  }
}

.detail .detail-main .detail-left .detail-left-list .detail-left-item div:first-child {
  flex-shrink: 0;
}

.detail .detail-main .detail-left .detail-left-list {
  padding-right: 20px;
}

.detail .detail-main .product-item .product-main .input-item .input-item-left {
  width: 73px !important;
}

.detail .detail-main .detail-left .detail-left-list .detail-left-item {
  align-items: flex-start !important;
}

.ml14 {
  margin-left: 14px;
}

.posi-center .posi-avatar .avatar-img img {
  width: 100%;
  height: 100%;
}

.groupselsect {
  z-index: 99999 !important;
}

.el-message {
  z-index: 99999 !important;
}

.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background-color: #f2f5f9 !important;
}
</style>
